import {
    IRecipientList,
    IInvoiceAttachmentOptions,
} from '../interfaces/IRecipientList';

export interface IInvoiceApiPayload {
    recipients: IRecipientList;
    attachmentOptions: IInvoiceAttachmentOptions;
}

export const createInvoiceFormData = (
    customerId: number,
    shipmentIds: number[],
    recipients: IRecipientList,
    attachmentOptions: IInvoiceAttachmentOptions,
): FormData => {
    const formData = new FormData();

    formData.append('CustomerId', customerId.toString());
    formData.append('ShipmentIds', JSON.stringify(shipmentIds));

    formData.append(
        'IsBolRequired',
        attachmentOptions.isBolRequired.toString(),
    );
    formData.append(
        'IsScaleTicketRequired',
        attachmentOptions.isScaleTicketRequired.toString(),
    );
    formData.append(
        'IsOtherRequired',
        attachmentOptions.isOtherRequired.toString(),
    );
    formData.append(
        'IsQuickBooksRequired',
        attachmentOptions.isQuickBooksRequired.toString(),
    );

    formData.append('Recipients', JSON.stringify(recipients));

    return formData;
};

export const createInvoicePayload = (
    recipients: IRecipientList,
    attachmentOptions: IInvoiceAttachmentOptions,
): IInvoiceApiPayload => ({
    recipients,
    attachmentOptions,
});

export const validateInvoicePrerequisites = (
    customerId?: number,
    shipmentIds?: number[],
): { isValid: boolean; error?: string } => {
    if (!customerId) {
        return { isValid: false, error: 'No customer ID provided' };
    }

    if (!shipmentIds || shipmentIds.length === 0) {
        return { isValid: false, error: 'No shipment IDs provided' };
    }

    return { isValid: true };
};
